import { Container } from './styles'
import { FiCheck } from 'react-icons/fi'
import PropTypes from 'prop-types'
import React from 'react'
import { Typography } from '@taglivros/tag-components'


export function StageNumber( { number, active, completed } ) {
  return (
    <Container
      active={ active }
      completed={ completed }
    >
      {completed ? (
        <FiCheck
          aria-label="Aprovado Check"
          color="#fff"
          role="img"
        /> ) : (
        // eslint-disable-next-line react/jsx-indent
        <Typography
          color="cinzaMenuSuperiorClaro"
          fontSizeDesktop="xs"
          fontSizeMobile="xxxs"
          fontWeight="l"
          variant="customText"
        >{ number }
        </Typography> )}
    </Container>
  )
}

StageNumber.propTypes = {
  'active': PropTypes.bool,
  'completed': PropTypes.bool,
  'number': PropTypes.number
}

StageNumber.defaultProps = {
  'active': false,
  'completed': false,
  'number': 1
}
